import request from '@/utils/request';

const urlParams = new URLSearchParams(window.location.search); // 获取查询字符串
const head = {
    aid: 'WEB',
    de: urlParams.get('de'),
    userId: urlParams.get('userId'),
    chkCode: urlParams.get('chkCode')
}

// im获取客服sgin
export const getQuerySignApi = (data: any = {}) => {
    return request({
        url: '/user-server/imClient/querySign',
        method: 'POST',
        data: {
            head,
            con: data
        },
    });
};

// 获取用户列表
export const getCustomerCustomersApi = (data: any) => {
    return request({
        url: '/customer-crm-server/customer/customers',
        method: 'POST',
        data: {
            head,
            con: data
        },
    });
};

// im获取用户信息
export const getQueryCustomerImInfoApi = (data: any) => {
    return request({
        url: '/user-server/imClient/queryCustomerImInfo',
        method: 'POST',
        data: {
            head,
            con: data
        },
    });
};

// im获取聊天记录
export const getQueryC2cMsgApi = (data: any) => {
    return request({
        url: '/user-server/imClient/queryC2cMsg',
        method: 'POST',
        data: {
            head,
            con: data
        },
    });
};

// 获取备注
export const queryCustomerRemarkApi = (data: any) => {
    return request({
        url: '/customer-crm-server/customer/queryCustomerRemark',
        method: 'POST',
        data: {
            head,
            con: data
        },
    });
};

// 获取订单
export const queryUserOrderApi = (data: any) => {
    return request({
        url: '/report-server/syMember/orderDetail',
        method: 'POST',
        data: {
            head,
            con: data
        },
    }); 
}

// 获取蔓迪星球订单
export const queryUserMdxqOrderApi = (data: any) => {
    return request({
        url: '/customer-crm-server/productsSorder/querySorderList',
        method: 'POST',
        data: {
            head,
            con: data
        },
    }); 
}

// 增加备注
export const addCustomerRemarkApi = (data: any) => {
    return request({
        url: '/customer-crm-server/customer/addCustomerRemark',
        method: 'POST',
        data: {
            head,
            con: data
        },
    }); 
}

// 编辑备注
export const editCustomerRemarkApi = (data: any) => {
    return request({
        url: '/customer-crm-server/customer/updateCustomerRemark',
        method: 'POST',
        data: {
            head,
            con: data
        },
    }); 
}

// 获取用户使用产品
export const queryUserProductApi = (data: any) => {
    return request({
        url: '/customer-crm-server/clockinProducts/customerArticles',
        method: 'POST',
        data: {
            head,
            con: data
        },
    }); 
}

// 搜索快捷语
export const searchQuickWordsApi = (data: any) => {
    return request({
        url: '/user-server/quickPhrase/queryPhrase',
        method: 'POST',
        data: {
            head,
            con: data
        },
    });  
}

// 批量发送单聊消息
export const batchSendC2cMsgApi = (data: any) => {
    return request({
        url: '/user-server/imClient/batchSendMessage',
        method: 'POST',
        data: data,
        // data: {
        //     head,
        //     con: data
        // },
    });
}
